<template>
  <div>
    <h1 class="privacy-policy-header text-secondary">{{ $t('common.privacyPolicy') }}</h1>
    <ol>
      <li class="clause" v-for="clause in $t('paidVersionPrivacyPolicy.clauses')" :key="clause.title">
        <h5 class="clause-title">{{ clause.title }}</h5>
        <p v-if="clause.body" class="clause-body text-pre-wrap">{{ clause.body }}</p>
        <div v-for="item in clause.items" :key="item" class="my-2">
          {{ item }}
        </div>
        <div v-for="subClause in clause.subClauses" :key="subClause.title" class="m-2">
          <p class="mb-1">{{ subClause.title }}</p>
          <p v-if="subClause.body" class="clause-body">
            {{ subClause.body }}
            <!-- とりあえずこれで -->
            <a href="/Waaarp個人情報共同利用者.pdf" target="_blank" v-if="subClause.attachedTableLink">別表に記載の販売店</a>
          </p>
          <div v-for="item in subClause.items" :key="item" class="m-2">
            {{ item }}
          </div>
        </div>
      </li>
    </ol>
    <div class="privacy-policy-footer text-secondary">
      <p>{{ $t('paidVersionPrivacyPolicy.footer.body') }}</p>
      <p class="text-right">{{ $t('paidVersionPrivacyPolicy.footer.end') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaidVersionPrivacyPolicyContent'
}
</script>

<style scoped lang="scss">
.clause {
  font-size: 1.25em;
  font-weight: bold;

  div {
    font-weight: normal;
  }
}
.clause-title {
  font-size: 1em;
  font-weight: bold;
}
.clause-body {
  padding-bottom: 1rem;
  font-size: 0.9em;
  font-weight: normal;
}
.privacy-policy-header {
  font-size: 2.5em;
  text-align: center;
  font-weight: bold;
  padding-bottom: 2rem;
}
.privacy-policy-footer {
  white-space: pre-wrap;
  font-weight: bold;
  padding-top: 1rem;
}
</style>
